/**
 * version-3/general/not-allow.php. Id-ul pastreaza spatiul din macheta.
 */
export function Forbidden() {
  return (
    <div id="content ">
      <div className="vertical-align">
        <div className="col-md-12 text-center  ">
          <div className="col-md-12 text-center ">
            <div className="col-md-12 center">
              <h1 className="text-danger">No access rights.</h1>
            </div>
            <div className="col-md-12 center" style={{ marginTop: 50 }}>
              <a href="/app/" className="btn btn-primary">
                Back to Home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function isForbidden(error: unknown): boolean {
  return error instanceof Error && 'status' in error && (error as { status: number }).status === 403
}
